/**
 * Twitch stream event parser
 */

/**
 * Parse Twitch stream event
 * @param {object} event - Raw Twitch event
 * @returns {object|null} Normalized event
 */
function parseTwitchEvent(event) {
  if (!event || !event.type) return null;
  
  const type = event.type.toLowerCase();
  const platform = 'twitch';
  
  // Extract user info
  const user = {
    username: event.username || event.user?.username || event.tags?.['display-name'] || 'Viewer',
    displayName: event.displayName || event.user?.displayName || event.tags?.['display-name'],
    imageUrl: event.imageUrl || event.user?.imageUrl || null,
    userId: event.userId || event.user?.id || event.tags?.['user-id']
  };
  
  // Common fields
  const base = {
    platform,
    user,
    id: event.id || event.tags?.id || `twitch_${Date.now()}_${Math.random()}`,
    timestamp: event.timestamp || Date.now()
  };
  
  switch (type) {
    case 'comment':
    case 'chat':
    case 'message':
      return {
        ...base,
        type: 'comment',
        message: event.comment || event.message || event.text || ''
      };
      
    case 'like':
    case 'cheer':
    case 'bits':
      return {
        ...base,
        type: 'like',
        likeCount: event.likeCount || event.bits || event.count || 1
      };
      
    default:
      return null;
  }
}

export { parseTwitchEvent };
